import { useCallback, useContext } from "react";
import { useSelector } from "react-redux";
import { ModalsWrapperContext } from "@kanda-libs/ks-component-ts";
import { useToast } from "@kanda-libs/ks-design-library";
import { actions } from "@kanda-libs/ks-frontend-services";
import jobSelectors from "store/selectors/job";
import { useAppDispatch } from "components/shared/App";
import { MODAL_ID } from "./constants";

export interface JobRevertHook {
  onRevertJob: () => void;
  isSubmitting: boolean;
  error?: string;
}

export default function useJobRevert(): JobRevertHook {
  const dispatch = useAppDispatch();
  const job = useSelector(jobSelectors.getEntity);
  const isSubmitting = useSelector(jobSelectors.getIsSubmitting);
  const { hideModal } = useContext(ModalsWrapperContext);
  const { showSuccess, showError } = useToast();

  const hideRevertModal = () => {
    hideModal(MODAL_ID);
  };

  const onRevertJob = useCallback(() => {
    const { id } = job || {};

    if (!id) return;

    dispatch(
      actions.overrideJob({
        body: { action: "mark_job_as_accepted" },
        params: { id },
        onError: () => {
          hideRevertModal();
          showError("Error overriding job and finance status");
        },
        onSuccess: () => {
          hideRevertModal();
          showSuccess("Job reverted");
        },
      })
    );
  }, [showError, showSuccess, job]);

  return {
    onRevertJob,
    isSubmitting,
  };
}
